<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>Affidavit Form</h1>
        <p>
          You may be eligible for Targeted Financial Assistance (TFA). Payments are made directly to the landlord to cover a tenant's past-due rent and fees plus two months' rent. Please be advised you should continue to pay your rent while your application is being reviewed. To complete your TFA application, please sign the tenant affidavit by typing your name and the date below.
          <br> 
          <br> 
          Click here to view the English version of the affidavit: <a
            :href="$tenantAffidavit"
            target="_blank"
          ><u>tenant affidavit</u></a>
          <br>
          <br>
          Click here to view the Spanish version of the affidavit: <a
            :href="$tenantAffidavitSpanish"
            target="_blank"
          ><u>tenant affidavit (Spanish)</u></a>
        </p>
      </div>
    </div>
    <ValidationObserver
      v-slot="{ errors }"
      tag="div"
    >
      <input-form
        ref="form"
        :errors="errors"
        name="TenantApplicationFrm"
        @submit.prevent="handleSubmit"
      >
        <!-- <br> -->
        <!-- <div class="columns">
          <div class="column">
            <input
              v-model="TFAInfoCheckbox"
              style="margin-right: 8px; vertical-align: middle;"
              true-value="1"
              false-value="0"
              type="checkbox"
            >
            <label>I would like to speak to a City Financial Specialist about Targeted Financial Assistance before signing the affidavit.</label>
          </div>
        </div> -->
        <!-- <div
          v-if="TFAInfoCheckbox == true" 
        >
          <callout type="info">
            Click submit and a City Financial Specialist will contact you an answer any questions you may have about the affidavit.
          </callout>
        </div> -->
        <br>
        <div
          v-if="TFAInfoCheckbox == false"
          class="columns"
        >
          <div class="column">
            <vee-textbox
              v-model="FullName"
              mode="eager"
              name="txt-full-name"
              placeholder="Full Name"
              rules="required"
              required
              error="This field is required"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="SignatureDate"
              :name="input-date"
              placeholder="Date"
              type="date"
              rules="required"
              required
              error="This field is required"
            />
          </div>
        </div>
        <callout type="danger">
          After this form is submitted, a City financial specialist will be assigned to your case for review, and you will be provided their contact information.
        </callout>
        <template #submit>
          <div class="actions columns">
            <div class="column is-2 is-offset-10">
              <button
                type="button"
                :disabled="
                  [SubmitStatus.Options.PENDING].includes(SubmitStatus)
                "
                class="button is-primary"
                @click="handleSubmit"
              >
                Submit
              </button>
            </div>
          </div>
          <div class="column">
            <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
              Submitting...
            </div>
          </div>
        </template>
      </input-form>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from "axios";
import buildTenantAffidavitSubmissionDataObject from "@/utilities/data-objects/tenant-affidavit-data-object";
import options from "@/utilities/options";
import {
  dataObjectToXml,
  getPropertyValueOrDefault,
} from "@/utilities/functions";

export default {
  name: "AffidavitForm",
  mixins: [options],
  props: {
    applicantId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      FullName: null,
      SignatureDate: null,
      TFAInfoCheckbox: false,
    };
  },
  methods:{
    async handleSubmit() {
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        const dataObject = buildTenantAffidavitSubmissionDataObject(vData);
        const xmlDataObject = dataObjectToXml(dataObject);
        const requestObject = {
          table: "btv4nxk25",
          action: "API_AddRecord",
          data: xmlDataObject,
        };

        axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-QuickBase-Request-Proxy",
            requestObject,
          )
          .then((qbResult) => {
            console.log(qbResult);
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
            
            vData.$router.push({
              name: "TenantSuccessPage",
              params: { applicantId: vData.applicantId },
            });
          });
      }
    },
  },
};
</script>